import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'demo-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './demo-table.component.html',
  styleUrl: './demo-table.component.scss',
})
export class DemoTableComponent {
  users = [
    {
      name: 'João da Silva',
      age: '23',
      address: 'Rua das Palmeiras, 149',
      phone: '41 6548-5545',
      document: '546.654.684-87',
    },
    {
      name: 'Maria Oliveira',
      age: '29',
      address: 'Avenida Brasil, 2020',
      phone: '21 9564-3321',
      document: '123.456.789-00',
    },
    {
      name: 'Carlos Pereira',
      age: '34',
      address: 'Rua das Laranjeiras, 300',
      phone: '11 9856-7854',
      document: '987.654.321-12',
    },
    {
      name: 'Ana Souza',
      age: '27',
      address: 'Avenida Atlantica, 1234',
      phone: '31 9785-4123',
      document: '321.654.987-54',
    },
    {
      name: 'Pedro Martins',
      age: '45',
      address: 'Rua das Flores, 567',
      phone: '51 6547-1234',
      document: '654.321.123-45',
    },
    {
      name: 'Lucas Almeida',
      age: '30',
      address: 'Rua dos Pinheiros, 789',
      phone: '81 9675-7841',
      document: '456.789.123-65',
    },
  ];
}
